import { render } from "./LoginVideoPreview.vue?vue&type=template&id=649e559c&ts=true"
import script from "./LoginVideoPreview.vue?vue&type=script&lang=ts"
export * from "./LoginVideoPreview.vue?vue&type=script&lang=ts"

import "./LoginVideoPreview.vue?vue&type=style&index=0&id=649e559c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__